"use client";

import React from "react";
import Styles from "./NSFooter.module.css";
import { NamirasoftAPILinkServer, FilterLinkFullRow } from 'namirasoft-api-link';
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IStorageLocal, CacheService } from "namirasoft-core";
import { PackageService } from "namirasoft-core";
import { EnvService } from 'namirasoft-core'
import { NSDialog } from "./NSDialog";

export interface NSFooterProps extends IBaseComponentProps
{
	scope: string;
	name: string;
	logo: string;
	isLoggedIn: () => boolean;
}

export interface NSFooterState
{
	filters: FilterLinkFullRow[];
	selected: FilterLinkFullRow | null;
	showDialog: boolean;
}

export class NSFooter extends React.Component<NSFooterProps, NSFooterState>
{
	private cache: CacheService<{
		rows: FilterLinkFullRow[];
		count: number;
	}>;
	constructor(props: NSFooterProps)
	{
		super(props);
		this.state = {
			filters: [],
			selected: null,
			showDialog: false
		};
		this.hasChild = this.hasChild.bind(this);
		this.render_menu = this.render_menu.bind(this);
		this.render_menuItem = this.render_menuItem.bind(this);
		this.cache = new CacheService<{
			rows: FilterLinkFullRow[];
			count: number;
		}>("ns-footer", new IStorageLocal(), 720, async () => "1.0.0", async () =>
		{
			let REACT_APP_BASE_URL_API_LINK = new EnvService("REACT_APP_BASE_URL_API_LINK", true).getString();
			let server = new NamirasoftAPILinkServer(REACT_APP_BASE_URL_API_LINK, console.error);
			return server.filter.ListFilterLinks(this.props.scope, this.props.name, null, null, null, []);
		});
	}
	override componentDidMount(): void
	{
		this.cache.get().then(filters =>
		{
			this.setState({ filters: filters.rows });
		}).catch(() => { });
	}
	private getFilters(): FilterLinkFullRow[]
	{
		let loggedin = this.props.isLoggedIn();
		let ans = this.state.filters?.filter(f =>
		{
			if (f.link)
			{
				if (loggedin)
					return f.link.private;
				return f.link.public;
			}
			return true;
		}) ?? [];

		while (true)
		{
			let old_length = ans.length;
			let old = ans;
			ans = ans.filter(f =>
			{
				if (f.link?.url)
					return true;
				return old.filter(x => x.parent_id === f.id).length > 0;
			});
			let new_length = ans.length;
			if (old_length === new_length)
				break;
		}

		return ans;
	}
	private hasChild(id: number): boolean
	{
		return this.getFilters().filter(f => f.parent_id === id).length > 0;
	}
	override render()
	{
		let REACT_APP_BASE_URL_ACCOUNT_CONSOLE = new EnvService("REACT_APP_BASE_URL_ACCOUNT_CONSOLE", true).getString();
		return (
			<>
				<footer id={this.props.id}
					className={`${Styles.ns_footer} ${this.props.classList?.join(" ") ?? ""}`}
					style={this.props.style}
				>
					{
						this.state.showDialog &&
						<NSDialog
							center_dialog={true}
							onClose={() =>
							{
								this.setState({ showDialog: false });
							}}
						>
							<pre>
								{
									JSON.stringify(PackageService.MainJson?.dependencies, null, 4)
								}
							</pre >
						</NSDialog>
					}
					<div className={`container ${Styles.ns_package_footer}`}>
						<div className={`${Styles.ns_footer_parent_items}`}>
							<div className={`${Styles.ns_footer_project_logo_tablet}`}>
								<a href="/">
									<img src={this.props.logo} alt='Logo' width={80} height={80} />
								</a>
								<span
									className={`${Styles.ns_footer_version}`}
									onClick={() =>
									{
										this.setState({ showDialog: true });
									}}
								>V{PackageService.MainJson?.version ?? "1.0.0"}</span>
							</div>
							<div className={`${Styles.ns_footer_menu_container}`}>
								{this.render_menu(0, null)}
							</div>
							<div className={`${Styles.ns_footer_namira_logo_tablet}`}>
								{/* Desktop  */}
								<div className="d-flex flex-row gap-3">
									<a href="https://namirasoft.com/">
										<img
											src="https://static.namirasoft.com/image/namirasoft/site/logo/circle.png"
											alt='Namira Software Corporation Logo'
											width={48}
											height={48}
										/>
									</a>
									<a href={REACT_APP_BASE_URL_ACCOUNT_CONSOLE}>
										<img
											src="https://static.namirasoft.com/image/namirasoft/account/logo/circle.png"
											alt='Namira Software Corporation Logo'
											width={48}
											height={48}
										/>
									</a>
								</div>
								{/* Social  */}
								<div className="d-flex flex-row gap-1 w-100 justify-content-center align-items-center">
									<a style={{ cursor: "pointer" }} href="https://ca.linkedin.com/company/namira-software-corporation" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/linkedin/white.svg"
											alt="Communicate with Namirasoft Via LinkedIn"
											width={24}
											height={24}
										/>
									</a>
									<a href="https://instagram.com/namira.software.corporation?igshid=MzRlODBiNWFlZA==" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/instagram/white.svg"
											alt="Communicate with Namirasoft Via Instagram"
											width={24}
											height={24}
										/>
									</a>
									<a href="mailto:accounts@namirasoft.com" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/email/white.svg"
											alt="Communicate with Namirasoft Via Email"
											width={24}
											height={24}
										/>
									</a>
									<a href="https://www.google.com/maps/place//@49.2781041,-123.1354814,14z/data=!4m2!3m1!1s0x0:0x18f70365c7a2f0fa?entry=s&sa=X" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/location/white.svg"
											alt="Communicate with Namirasoft in Person"
											width={24}
											height={24}
										/>
									</a>
								</div>
							</div>
						</div>
						<div className={`${Styles.ns_footer_logos_mobile}`}>
							{/* Mobile  */}
							<div className="d-flex flex-column gap-4">
								<div className="d-flex flex-row gap-3">
									<a href="https://namirasoft.com/">
										<img
											src="https://static.namirasoft.com/image/namirasoft/site/logo/circle.png"
											alt='Namira Software Corporation Logo'
											width={48}
											height={48}
										/>
									</a>
									<a href={REACT_APP_BASE_URL_ACCOUNT_CONSOLE}>
										<img
											src="https://static.namirasoft.com/image/namirasoft/account/logo/circle.png"
											alt='Namira Software Corporation Logo'
											width={48}
											height={48}
										/>
									</a>
								</div>
								{/* Social  */}
								<div className="d-flex flex-row gap-1 w-100 justify-content-center align-items-center">
									<a href="https://ca.linkedin.com/company/namira-software-corporation" target="_blank" rel="noreferrer" >
										<img
											src="https://static.namirasoft.com/image/concept/social/linkedin/white.svg"
											alt="Communicate with Namirasoft Via LinkedIn"
											width={24}
											height={24}
										/>
									</a>
									<a href="https://instagram.com/namira.software.corporation?igshid=MzRlODBiNWFlZA==" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/instagram/white.svg"
											alt="Communicate with Namirasoft Via Instagram"
											width={24}
											height={24}
										/>
									</a>
									<a href="mailto:accounts@namirasoft.com" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/email/white.svg"
											alt="Communicate with Namirasoft Via Email"
											width={24}
											height={24}
										/>
									</a>
									<a href="https://www.google.com/maps/place//@49.2781041,-123.1354814,14z/data=!4m2!3m1!1s0x0:0x18f70365c7a2f0fa?entry=s&sa=X" target="_blank" rel="noreferrer">
										<img
											src="https://static.namirasoft.com/image/concept/social/location/white.svg"
											alt="Communicate with Namirasoft in Person"
											width={24}
											height={24}
										/>
									</a>
								</div>
								<div className={`${Styles.ns_footer_version}`}
									onClick={() =>
									{
										this.setState({ showDialog: true });
									}}
								>Version: {PackageService.MainJson?.version ?? "1.0.0"}</div>
							</div>
						</div>
						<div className={`${Styles.ns_footer_copyright}`}>
							<span> ©Copyright 2010 -  {new Date().getFullYear()}  </span>{" "}
							<a href="https://namirasoft.com/" target="_blank" rel="noreferrer"> Namira Software Corporation</a>. {" "}
							<span > All rights reserved. </span>
						</div>
					</div>
				</footer >
			</>
		);
	}
	private render_menu(level: number, parent_id: number | null)
	{
		let fs: FilterLinkFullRow[] = this.getFilters().filter(f => f.parent_id === parent_id);
		return (
			<>
				{
					(fs?.map(f => this.render_menuItem(level, f)))
				}
			</>
		);
	}
	private render_menuItem(level: number, filter: FilterLinkFullRow)
	{
		if (this.hasChild(filter.id))
		{
			return (
				<ul key={filter.id}
					id={`dropdown_parent${filter.id}`}>
					<span className={Styles.ns_footer_list_title}> {filter.name} </span>
					{this.render_menu(1, filter.id)}
				</ul>
			);
		}
		else if (level === 0)
		{
			return (
				<ul
					key={filter.id}
					id={`dropdown_parent${filter.id}`}>
					{filter.name}
				</ul>
			);
		}
		else
		{
			let href = filter.link?.url;
			if (process.env.REACT_APP_STANDALONE)
				if (href)
				{
					let url = new URL(href);
					url.host = window.location.host;
					url.protocol = window.location.protocol;
					href = url.toString();
				}
			return (
				<li key={filter.id} className="mb-2">
					<a href={href} target="_blank" rel="noreferrer">
						{filter.name}
					</a>
				</li>
			);
		}
	}
}